/** Filtros de Congregacion (select mayorap2 / prod). */
export enum CongregacionFiltro {
  Ninguno = '',
  Muelle = 'filtroMuelle',
  Faltas = 'filtroFaltas',
  Monitoreo = 'filtroMonitoreo',
  Cumple = 'filtroCumple',
  Estudiantes = 'filtroEstudiantes',
  Lideres = 'filtroLideres',
  PorNombre = 'filtroPorNombre',
}
